import type { RelatedPlayersOptions, PlayerItem } from './types';

import { fetchPlayersById } from '@apis/players';
import type { Player } from '@shared-types/match.types';
import { loadFromAPIs } from '@utilities/fetch';
import { competitionId } from '@utilities/WindowContext';

export const loadPlayersFromFpz = (
  { competitionGroup, seasonYear, fieldPosition, playerId, limit, clubId, teamId }: RelatedPlayersOptions,
  type?: 'club' | 'team' | null,
) =>
  loadFromAPIs<{ player: PlayerItem }[]>(
    'v1/rankings',
    {
      competitionGroup: competitionGroup,
      seasonYear: seasonYear ?? 'current',
      fieldPosition: fieldPosition?.toUpperCase() ?? null,
      limit: type ? limit * 3 : limit * 20,
      offset: 0,
      teamId: type === 'club' ? clubId : type === 'team' ? teamId : null,
    },
    {
      apiKey: window.apiKey,
      apiUrl: window.performanceApiBaseUrl,
    },
  ).then((players) => {
    const currentPlayerId = playerId;
    // remove current player from players list, if applicable
    return (players ?? []).map(({ player }) => player).filter((p: Player) => p.id !== currentPlayerId);
  });

export const loadFullPlayerData = ({ seasonYear }: RelatedPlayersOptions, playerIds: string[]) =>
  fetchPlayersById({
    playerIds,
    competitionContext: competitionId ? `${competitionId}:${seasonYear}` : null,
  });
